import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'






function Product() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(750);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [member, setMember] = useState([])
    const navigate = useNavigate()

    const memberCollectionRef = collection(db, "Products");
    useEffect(() => {

        const getMember = async () => {
            const data = await getDocs(memberCollectionRef);
            setMember(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }
        getMember()
    }, [])
    return (

        <>


            <div className='product'>






                <div className="album py-2">

                    <div className="container">

                        <div className="row">

                            <div className="col-md-6">

                                <div className="card-body">
                                    <input type="text" className="form-control" placeholder="Search.. " name="location"
                                        onChange={(e) => {
                                            setsearchTerm(e.target.value);
                                        }}
                                    />
                                    <div className="d-flex justify-content-between align-items-center">




                                    </div>


                                </div>


                            </div>

                        </div>

                    </div>
                </div>
                <div className="album py-2">

                    <div className="container">

                        <div className="row">
                            {member.filter((val) => {
                                if (setsearchTerm === "") {
                                    return val;
                                } else if (
                                    val.title.toLowerCase().includes(searchTerm.toLowerCase())



                                ) {
                                    return val;
                                }
                            }).slice(pagination.start, pagination.end).map((masterofsecuritysystem) => {
                                return (

                                    <div className="col-md-3">
                           <div className="card mb-4 border-White box">
                                            <img className="card-img-top same-size-img" src={masterofsecuritysystem.img} alt={masterofsecuritysystem.title} />
                                            <div className="card-body">
                                                <h5 style={{ color: "#081451" }} className="card-text mb-1"> <b>{masterofsecuritysystem.title}</b></h5>
                                                <p style={{ color: "#090c6bff" }} className="card-tex mb-2"> {masterofsecuritysystem.des}</p>
                                                <p style={{ color: "#090c6bff" }} className="card-tex mb-1"><del> ₹{masterofsecuritysystem.mrp}</del></p>

                                                <h5 style={{ color: "#561111ff" }} className="card-text mb-2"> <b>₹{masterofsecuritysystem.price}</b></h5>

                                                <a href='tel:  9064797437'>
                                                    <button className='callbutton'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                                                    </svg>  9064797437</button>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

        </>

    );
}

export default Product;